import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const TOKEN_KEY = 'client_token';
const USER_KEY = 'client_user';

export const getClientToken = () => localStorage.getItem(TOKEN_KEY) || '';
export const getStoredClient = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); } catch { return null; }
};
export const storeClientSession = (token, client) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(client));
};
export const clearClientSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

const authHeaders = () => ({ Authorization: `Bearer ${getClientToken()}` });

export const clientGet = (path, params = {}) => axios.get(`${BACKEND_URL}${path}`, { params, headers: authHeaders() });
export const clientPost = (path, body = {}) => axios.post(`${BACKEND_URL}${path}`, body, { headers: authHeaders() });
export const publicPost = (path, body = {}) => axios.post(`${BACKEND_URL}${path}`, body);

/** Mobile browsers open PDFs in a new tab without headers: pass the token as a query param. */
export const invoicePdfUrl = (invoiceId) =>
  `${BACKEND_URL}/api/client/invoices/${invoiceId}/pdf?token=${encodeURIComponent(getClientToken())}`;

export const reportPhotoUrl = (reportId, index) =>
  `${BACKEND_URL}/api/client/reports/${reportId}/photos/${index}?token=${encodeURIComponent(getClientToken())}`;

export const qcPhotoUrl = (controlId, index) =>
  `${BACKEND_URL}/api/client/qualite/${controlId}/photos/${index}?token=${encodeURIComponent(getClientToken())}`;

export const errorMessage = (error, fallback = 'Une erreur est survenue') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  if (error?.response?.status === 429) return 'Trop de tentatives, patientez une minute';
  return error?.message || fallback;
};

export const isUnauthorized = (error) => error?.response?.status === 401;

export const fmtMoney = (n) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n || 0);
export const fmtDate = (iso, opts = { weekday: 'long', day: 'numeric', month: 'long' }) => (iso ? new Date(iso).toLocaleDateString('fr-FR', opts) : '');
export const fmtShortDate = (iso) => (iso ? new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '');
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '--:--');
export const fmtMinutes = (mins) => {
  const m = Math.max(0, Math.round(mins || 0));
  return `${Math.floor(m / 60)}h${String(m % 60).padStart(2, '0')}`;
};

export const AGENCY_PHONE = '03 74 47 47 82';
export const AGENCY_PHONE_HREF = 'tel:+33374474782';
